import { BRANDS } from '../brand/brands';

/** The Moderta parent accent on the dark stage (derived from moderta.com #00796B; see src/brand/brands.ts). */
export const BRAND_ACCENT = BRANDS.moderta.accent;
